import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { generateJWTToken } from "src/app/core/helpers/jwt-token.utils";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ListingsService {

  constructor(private http: HttpClient) {}

  public loadAllListings(accountId: any, userId: any): Observable<any> {
    const payloadObj = {
      iss: 'https://platform.renderseo.com', // Might have to change this url....
      sub: userId, // user id
      account_id: accountId,
      iat: new Date().getTime(),
      exp: new Date().getTime() + 3 * 6000,
    };
    const jwtToken = generateJWTToken(payloadObj, '2c4c4d06f0b35b921039d9df2725205d981ac00bf196eb71b02ce7571432e30a');
    const headers = new HttpHeaders().set('Authorization', `${jwtToken}`);
    const url: string = `https://io.renderseo.com/listings`;
    return this.http.get(url, { headers: headers });
  }

  public loadListingMatches(accountId: any, userId: any, listingId: any): Observable<any> {
    const [publisher, locationId] = listingId.split('#');
    const payloadObj = {
      iss: 'https://platform.renderseo.com',
      sub: userId,
      account_id: accountId,
      iat: new Date().getTime(),
      exp: new Date().getTime() + 3 * 6000,
    };
    const jwtToken = generateJWTToken(payloadObj, '2c4c4d06f0b35b921039d9df2725205d981ac00bf196eb71b02ce7571432e30a');
    const headers = new HttpHeaders().set('Authorization', `${jwtToken}`);
    const url: string = `https://io.renderseo.com/listings/matches/${locationId}?publisher=${publisher}`;
    return this.http.get(url, { headers: headers });
  }

  public generateListingMatches(accountId: any, userId: any, listingId: any): Observable<any> {
    const [publisher, locationId] = listingId.split('#');
    const payloadObj = {
      iss: 'https://platform.renderseo.com',
      sub: userId,
      account_id: accountId,
      iat: new Date().getTime(),
      exp: new Date().getTime() + 3 * 6000,
    };
    const jwtToken = generateJWTToken(payloadObj, '2c4c4d06f0b35b921039d9df2725205d981ac00bf196eb71b02ce7571432e30a');
    const headers = new HttpHeaders().set('Authorization', `${jwtToken}`);
    const url: string = `https://io.renderseo.com/listings/matches/${locationId}?publisher=${publisher}`;
    return this.http.post(url, {}, { headers: headers });
  }

  public saveSelectedMatch(accountId: any, userId: any, listingId: any, matchId: any): Observable<any> {
    const [publisher, locationId] = listingId.split('#');
    const payloadObj = {
      iss: 'https://platform.renderseo.com',
      sub: userId,
      account_id: accountId,
      iat: new Date().getTime(),
      exp: new Date().getTime() + 3 * 6000,
    };
    const jwtToken = generateJWTToken(payloadObj, '2c4c4d06f0b35b921039d9df2725205d981ac00bf196eb71b02ce7571432e30a');
    const headers = new HttpHeaders().set('Authorization', `${jwtToken}`);
    const url: string = `https://io.renderseo.com/listings/matches/${locationId}/select?publisher=${publisher}&match_id=${matchId}&selected_by=${userId}`;
    return this.http.post(url, {}, { headers: headers });
  }

  public createListing(accountId: any, userId: any, listingId: any): Observable<any> {
    const matchId = 'new'
    const [publisher, locationId] = listingId.split('#');
    const payloadObj = {
      iss: 'https://platform.renderseo.com',
      sub: userId,
      account_id: accountId,
      iat: new Date().getTime(),
      exp: new Date().getTime() + 3 * 6000,
    };
    const jwtToken = generateJWTToken(payloadObj, '2c4c4d06f0b35b921039d9df2725205d981ac00bf196eb71b02ce7571432e30a');
    const headers = new HttpHeaders().set('Authorization', `${jwtToken}`);
    const url: string = `https://io.renderseo.com/listings/matches/${locationId}/select?publisher=${publisher}&match_id=${matchId}&selected_by=${userId}`;
    return this.http.post(url, {}, { headers: headers });
  }

  public generateListingMatchesForAll(accountId: any, userId: any, publisher): Observable<any> {
    const payloadObj = {
      iss: 'https://platform.renderseo.com',
      sub: userId,
      account_id: accountId,
      iat: new Date().getTime(),
      exp: new Date().getTime() + 3 * 6000,
    };
    const jwtToken = generateJWTToken(payloadObj, '2c4c4d06f0b35b921039d9df2725205d981ac00bf196eb71b02ce7571432e30a');
    const headers = new HttpHeaders().set('Authorization', `${jwtToken}`);
    const url: string = `https://io.renderseo.com/listings/matches?publisher=${publisher}`;
    return this.http.post(url, {}, { headers: headers });
  }
}
